// HEPI product page: gallery thumbnails, variant picker (only for multi-variant products),
// add to cart (main button + sticky mobile bar). Cart itself: hepi-cart.js.
(function(){
  function money(cents){
    var n=cents/100;
    return n.toLocaleString('en-US',{minimumFractionDigits:(n%1)?2:0,maximumFractionDigits:2})+' \u20aa';
  }

  document.addEventListener('DOMContentLoaded',function(){
    var atc=document.getElementById('pdAtcBtn');
    var sticky=document.querySelector('[data-sticky]');
    var stickyBtn=document.querySelector('[data-sticky-atc]');
    var atcLabel=atc?atc.innerHTML:'';

    // Gallery: thumbnails scroll the strip; swiping updates the active thumbnail
    var track=document.querySelector('[data-gallery-track]');
    var thumbs=[].slice.call(document.querySelectorAll('[data-thumb]'));
    function setActive(i){
      thumbs.forEach(function(t,j){t.classList.toggle('is-active',j===i);t.setAttribute('aria-current',j===i?'true':'false');});
    }
    thumbs.forEach(function(t,i){
      t.addEventListener('click',function(){
        var s=document.getElementById('pdpImg'+(i+1));
        if(s)s.scrollIntoView({behavior:'smooth',block:'nearest',inline:'start'});
        setActive(i);
      });
    });
    if(track&&thumbs.length&&'IntersectionObserver' in window){
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(e){if(e.isIntersecting)setActive(parseInt(e.target.getAttribute('data-slide'),10));});
      },{root:track,threshold:0.6});
      track.querySelectorAll('[data-slide]').forEach(function(s){io.observe(s);});
    }

    // Add to cart (main button + sticky bar)
    function addNow(btn){
      if(!atc||atc.disabled)return;
      window.addToCartAjax(parseInt(atc.getAttribute('data-variant'),10),btn);
    }
    if(atc)atc.addEventListener('click',function(){addNow(atc);});
    if(stickyBtn)stickyBtn.addEventListener('click',function(){addNow(stickyBtn);});

    // Sticky bar: visible only while the main button is off-screen
    if(atc&&sticky&&'IntersectionObserver' in window){
      new IntersectionObserver(function(entries){sticky.hidden=entries[0].isIntersecting;}).observe(atc);
    }

    // Variant picker (rendered only when the product has options)
    var vEl=document.getElementById('pdpVariants');
    if(!vEl||!atc)return;
    var variants=JSON.parse(vEl.textContent);
    var groups=[].slice.call(document.querySelectorAll('.hepi-pdp__opt'));
    var sel=groups.map(function(g){var b=g.querySelector('.var-opt.selected');return b?b.getAttribute('data-val'):null;});
    var priceEl=document.querySelector('[data-price]');
    var compareEl=document.querySelector('[data-compare]');
    var saveEl=document.querySelector('[data-save]');
    var stickyPrice=document.querySelector('[data-sticky-price]');

    function update(v){
      if(!v){
        atc.disabled=true;atc.textContent='השילוב הזה לא זמין';
        if(stickyBtn)stickyBtn.disabled=true;
        return;
      }
      atc.setAttribute('data-variant',v.id);
      atc.disabled=!v.available;
      atc.innerHTML=v.available?atcLabel:'אזל מהמלאי';
      if(stickyBtn)stickyBtn.disabled=!v.available;
      if(priceEl)priceEl.textContent=money(v.price);
      if(stickyPrice)stickyPrice.textContent=money(v.price);
      var sale=v.compare_at_price&&v.compare_at_price>v.price;
      if(compareEl){compareEl.hidden=!sale;compareEl.textContent=sale?money(v.compare_at_price):'';}
      if(saveEl){saveEl.hidden=!sale;saveEl.innerHTML=sale?'חוסכים <span dir="ltr">'+money(v.compare_at_price-v.price)+'</span>':'';}
      if(window.history&&history.replaceState)history.replaceState(null,'','?variant='+v.id);
    }

    document.querySelectorAll('.var-opt[data-opt]').forEach(function(b){
      b.addEventListener('click',function(){
        var i=parseInt(b.getAttribute('data-opt'),10);
        sel[i]=b.getAttribute('data-val');
        b.parentNode.querySelectorAll('.var-opt').forEach(function(x){x.classList.toggle('selected',x===b);x.setAttribute('aria-pressed',x===b?'true':'false');});
        var lbl=document.querySelector('[data-opt-label="'+i+'"]');if(lbl)lbl.textContent=sel[i];
        update(variants.find(function(v){return v.options.every(function(o,k){return o===sel[k];});}));
      });
    });
  });
})();
